import { useEffect } from "react";

export type ShortcutName = "add" | "edit" | "save" | "cancel" | "next" | "previous";

export const SHORTCUT_KEYS: Record<ShortcutName, { key: string; label: string; description: string }> = {
  add: { key: "a", label: "Alt+A", description: "Add" },
  edit: { key: "e", label: "Alt+E", description: "Edit" },
  save: { key: "s", label: "Alt+S", description: "Save" },
  cancel: { key: "c", label: "Alt+C", description: "Cancel" },
  next: { key: "n", label: "Alt+N", description: "Next page" },
  previous: { key: "p", label: "Alt+P", description: "Previous page" },
};

export type ShortcutHandlers = Partial<Record<ShortcutName, () => void>>;

/** Screens declare handlers by name; the hook owns the key bindings (Alt + letter). */
export function useShortcuts(handlers: ShortcutHandlers): void {
  useEffect(() => {
    const handleKeyDown = (event: KeyboardEvent) => {
      if (!event.altKey || event.ctrlKey || event.metaKey) return;
      const pressed = event.key.toLowerCase();
      const entry = (Object.keys(SHORTCUT_KEYS) as ShortcutName[]).find((name) => SHORTCUT_KEYS[name].key === pressed);
      if (!entry) return;
      const handler = handlers[entry];
      if (!handler) return;
      event.preventDefault();
      handler();
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [handlers]);
}
